
import { useEffect, useState } from 'react';
import { AvailablePageVersion } from '../../types/pageversiontypes';
import { fetchAvailablePageVersions } from '../../services/pageversionservice';

const draftStatusGuid = "2c6eaa3f-f669-4504-8f7b-17c27a0df1f7";
const appendText = " (Draft)";

export function useAvailablePageVersions({
    currentPageVersionGuid,
    hasPageVersionStatusChanged,
    hasPageVersionNameChanged,
}: {
    currentPageVersionGuid: string;
    hasPageVersionStatusChanged: boolean;
    hasPageVersionNameChanged: boolean;
}) {
    const [availablePageVersions, setAvailablePageVersions] = useState<AvailablePageVersion[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const rawVersions = await fetchAvailablePageVersions();
                const transformed = rawVersions.map((item) =>
                    item.statusGuid === draftStatusGuid
                        ? { ...item, name: item.name + appendText }
                        : item
                );
                setAvailablePageVersions(transformed);
            } catch (error) {
                console.error('Error fetching available page versions:', error);
            }
        };

        fetchData();
    }, [currentPageVersionGuid, hasPageVersionStatusChanged, hasPageVersionNameChanged]);

    return { availablePageVersions, setAvailablePageVersions };
}